import * as React from 'react'
import { useParams, useOutletContext } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Alert } from '@mui/material'
import { features as setFeature } from '../../redux/slices/Tree/treeFeatures'
import LinearInderterminate from '../LinearIndeterminate'
import { getAllLocations, isVaidTree } from '../../services'
import ContentOptions from '../ContentOptions'
import ManagementInfo from '../ManagementInfo'
import ItemsFormik from './ItemsFormik'
import AlertCustom from '../Alerts'

const contentStyle = {
  width: '100%',
  height: '100%',
  textAlign: 'center',
}

const TreeManagementPage = ({ roleUser }) => {
  const { treeId } = useParams()
  const dispatch = useDispatch()
  const [isValidURL, setIsValidURL] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [alert, showAlert] = React.useState(false)

  const [setContent, setPopupLngLat, allOption, mapTree] = useOutletContext()

  const { features } = useSelector(state => state.treeFeatures.data)
  const featureTreeCode = features?.filter(obj => obj.properties.id === treeId)

  React.useEffect(() => {
    isVaidTree(treeId)
      .then(res => {
        if (!res.valid) showAlert(true)
      })
      .catch(err => console.log('Error :>> ', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    setLoading(true)
  }, [treeId])

  React.useEffect(() => {
    if (Boolean(features.length)) return
    getAllLocations()
      .then(geojson => {
        if (!Object.keys(geojson).length) {
          console.log('No se pudo cargar los datos. Intente más tarde.')
        } else dispatch(setFeature(geojson))
      })
      .catch(err => console.log('Error :>> ', err.message))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [features])

  React.useEffect(() => {
    if (!loading) return
    if (!Boolean(features.length)) return
    if (!Boolean(featureTreeCode.length)) {
      setLoading(false)
      return
    }
    const code = featureTreeCode[0].properties.code
    const coordinates = featureTreeCode[0].geometry.coordinates.slice()
    const passProps = { code, coordinates, key: code, allOption, mapTree } //AllOptions si es Admin only
    setPopupLngLat(coordinates)
    setContent(<ContentOptions {...passProps} />)
    // mapTree.current.flyTo({ center: coordinates, duration: 1500, essential: true })
    setIsValidURL(true)
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [features, loading])

  if (!isValidURL)
    return (
      <Box
        style={{
          width: '100%',
          height: '100%',
          overflow: 'auto',
          scrollBehavior: 'smooth',
        }}>
        {!loading && alert ? (
          <Box>
            <ManagementInfo roleUser={roleUser}>
              <Alert severity="error">
                La URL tiene un ID árbol no válido. No se encontraron datos.
              </Alert>
            </ManagementInfo>
            <AlertCustom severity="error" stateInitial={alert}>
              Identificador del árbol incorrecto.
            </AlertCustom>
          </Box>
        ) : (
          <LinearInderterminate />
        )}
      </Box>
    )

  return (
    <Box sx={contentStyle}>
      <ItemsFormik />
    </Box>
  )
}

export default React.memo(TreeManagementPage)
